// import LoginSendCode from 'assets/images/login/login hojre 1.svg';

import logo from 'assets/logo/hoje logo.svg';
import {useLocation} from 'react-router-dom';
const LoginHeader = () => {
  const {pathname} = useLocation();

  let title = '';
  let secondTitle = '';
  let isLogoTop = false;

  switch (pathname) {
    case '/auth/login':
      title = 'ورود';
      secondTitle = 'جهت ورود به حجره شماره تلفن خود را وارد کنید.';
      break;
    case '/auth/confirmation':
      title = 'ورود';
      secondTitle = 'جهت ورود به حجره کد تأیید را وارد کنید.';
      break;
    case '/auth/signUp':
      title = 'عضوریت';
      secondTitle = 'لطفا اطلاعات کاربری خود را وارد کنید.';
      isLogoTop = true;
      break;
    default:
      title = '';
      secondTitle = '';
      break;
  }

  return (
    <div className={`${isLogoTop ? 'mt-10' : 'mt-32'}  text-right`}>
      <img
        alt="login send code"
        src={logo}
        className={`${isLogoTop ? 'mb-2' : 'mb-8'}  block m-auto w-36  h-20`}
      />
      <p className="  font-normal  text-sm  text-gray-800">{title}</p>
      <p className="mt-2 font-normal  text-xs text-gray-400">{secondTitle}</p>
    </div>
  );
};

export default LoginHeader;
